import { render } from "./addConfig.vue?vue&type=template&id=e5578a1a&scoped=true"
import script from "./addConfig.vue?vue&type=script&lang=js"
export * from "./addConfig.vue?vue&type=script&lang=js"

import "./addConfig.vue?vue&type=style&index=0&id=e5578a1a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mamidou/mamidou/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5578a1a"]])

export default __exports__